<template>
  <basic-container>
    <div class="search-contain">
      <el-form ref="query" :model="query" :inline="true" size="mini">
        <el-form-item label="日期:">
          <avue-date
              v-model="queryTimes"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              valueFormat="yyyy-MM-dd HH:mm:ss"
              @change="handleChangeTimes">
          </avue-date>
        </el-form-item>
        <el-form-item label="供应商:">
          <avue-select v-model="query.merchantId" :dic="merchantDic" :props="{ label: 'merchantName', value: 'merchantId' }" filterable placeholder="试试搜索:请选择供应商"></avue-select>
        </el-form-item>
        <el-form-item label="司机信息:">
          <avue-select
              v-model="query.driverPhone"
              :dic="driverDic"
              filterable
              :props="{ label: 'driverInfo', value: 'driverPhone' }"
              placeholder="试试搜索: 请选择司机信息"></avue-select>
        </el-form-item>
        <el-form-item label="订单号:">
          <el-input v-model.trim="query.orderNo" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="车辆信息:">
          <el-input v-model="query.plateNumber" placeholder="请输入车牌号"></el-input>
        </el-form-item>
        <el-form-item label="类型:">
          <avue-select v-model="query.tripType" :dic="[{ label: '接', value: 1 }, { label: '送', value: 2 }]" placeholder="请选择行程类型"></avue-select>
        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              icon="el-icon-search"
              @click="searchChange">筛选</el-button>
          <el-button
              type="danger"
              icon="el-icon-delete"
              @click="searchReset">清空</el-button>
        </el-form-item>
      </el-form>
    </div>
    <avue-crud
        ref="crud"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        :option="option"
        @current-change="currentChange"
        @size-change="sizeChange"
        @refresh-change="refreshChange"
        @on-load="onLoad">
      <template slot="orderNo" slot-scope="{row}">
        <el-button type="text" size="mini" @click.stop="handleOrderDetails(row)">{{ row.orderNo }}</el-button>
      </template>
      <template slot-scope="{row}" slot="orderStatus">
        <el-tag size="small">{{row.orderStatus | orderStatusFilter}}</el-tag>
      </template>
      <template slot="menuLeft">
        <el-button type="primary" size="small">导出汇总表</el-button>
      </template>
    </avue-crud>
    <!--订单详情-->
    <order-details-statis ref="orderDetails" v-if="showDialog"></order-details-statis>
  </basic-container>
</template>

<script>
  import { querySelectDicMixins } from "@/mixins/selectTree"
  import { getDetailsStatis } from '@/api/statis'
  import orderDetailsStatis from './order-details-statis'
  export default {
    name: "detailsStatis",
    mixins: [querySelectDicMixins],
    components: { orderDetailsStatis },
    filters: {
      orderStatusFilter(orderStatus) {
        let mark = ''
        switch (orderStatus) {
          case 1:
            mark = '待支付'
            break
          case 2:
            mark = '待接单'
            break
          case 3:
            mark = '待出发'
            break
          case 4:
            mark = '取消'
            break
          case 5:
            mark = '接人中'
            break
          case 6:
            mark = '待乘客上车'
            break
          case 7:
            mark = '行程中'
            break
          case 8:
            mark = '送达完成'
            break
          case 9:
            mark = '已退款'
            break
          case 10:
            mark = '取消失败'
            break
        }
        return mark
      }
    },
    data() {
      return {
        loading: true,
        showDialog: false,
        sid: '',
        stype: '',
        query: {},
        queryTimes: [],
        page: {
          currentPage: 1,
          pageSizes: [10,20,30,50,100],
          pageSize: 10
        },
        data: [],
        option: {
          menuAlign: 'center',
          align:'center',
          addBtn: false,
          delBtn:false,
          editBtn:false,
          viewBtn: false,
          simplePage: false,
          dialogClickModal: false,
          index: true,
          tip: false,
          border: true,
          selection: true,
          menu: false, // 隐藏操作列
          column: [
            {
              label: '订单号',
              prop: 'orderNo',
              width: 180,
            },
            {
              label: '订单状态',
              prop: 'orderStatus',
              width: 120,
            },
            {
              label: '出发地-目的地',
              prop: 'startEndAddress',
              width: 180,
            },
            {
              label: '行程类型',
              prop: 'tripType',
              width: 80,
              dicData: [
                {
                  label: '接人',
                  value: 1
                },
                {
                  label: '送人',
                  value: 2
                }
              ]
            },
            {
              label: '供应商',
              prop: 'merchantName',
              width: 200,
            },
            {
              label: '司机信息',
              prop: 'driverInfo',
              width: 150,
            },
            {
              label: '车辆信息',
              prop: 'plateNumber',
              width: 120,
            },
            {
              label: '公里数(公里)',
              prop: 'distance',
              width: 90,
            },
            {
              label: '服务人数',
              prop: 'serverPepleNumber',
              width: 90,
            },
            {
              label: '实付金额(元)',
              prop: 'payAmount',
              width: 90,
            },
            {
              label: '结算金额(元)',
              prop: 'settleAmount',
              width: 90,
            }
          ]
        }
      }
    },
    created() {
      this.sid = this.$route.params && this.$route.params.id;
      this.stype = this.$route.params && this.$route.params.type
      console.log(this.stype)
      if (this.sid && this.stype === 'supplier') {
        this.query.merchantId = this.sid
      }
      if (this.sid && this.stype === 'driver') {
        this.query.driverId = this.sid
      }
      if (this.sid && this.stype === 'car') {
        this.query.carId = this.sid
      }
    },
    methods: {
      searchChange() {
        this.page.currentPage = 1
        this.onLoad(this.page, this.query)
      },
      searchReset() {
        if (this.stype === 'supplier') {
          this.query.merchantId = this.sid
        }
        if (this.stype === 'driver') {
          this.query.driverId = this.sid
        }
        if (this.stype === 'car') {
          this.query.carId = this.sid
        }

        this.onLoad(this.page)
      },
      handleChangeTimes(val) {
        this.query.startUpdateTime = val[0]
        this.query.endUpdateTime = val[1]
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize
      },
      refreshChange() {
        this.onLoad(this.page)
      },
      onLoad(page, params = {}) {
        this.loading = false
        const query = {
          current: this.page.currentPage,
          size: this.page.pageSize,
          ...this.query
        }
        getDetailsStatis(Object.assign(params, query)).then(resp => {
          this.loading = false
          this.data = resp.data.records
          this.page.total = resp.data.total
        })
      },
      handleOrderDetails(row) {
        this.showDialog = true
        this.$nextTick(() => {
          this.$refs.orderDetails.init(row)
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .search-contain{
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  ::v-deep .el-date-editor--datetimerange.el-input__inner {
    width: 214px;
  }
</style>
